import {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Avatar, Badge, ButtonGroup } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { addDoc, collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { timeConvert } from '../../helpers';
import { groupTimeMinutes } from 'shared';
import { useParams } from 'react-router-dom';

const theme = createTheme();

export default function Join() {
  const [count, setCount] = useState(1);
  const [waitTime, setWaitTime] = useState(0);
  const [showSuccess, toggleSuccess] = useState(false);
  const location = useParams().location || 'sydney';

  useEffect(() => {
    const q = query(collection(db, `ques/${location}/guests`), where("status", "==", "waiting"))
    onSnapshot(q, (querySnapshot) => {
      setWaitTime((querySnapshot.docs.length-1) * groupTimeMinutes)
    });
  }, [location])

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
  
    const ref = collection(db, `ques/${location}/guests`)
    addDoc(ref, {
      name: `${data.get('firstName')} ${data.get('lastName')}`,
      mobile: data.get('phone'),
      groupSize: parseInt(data.get('groupSize')),
      status: "waiting",
      created: new Date().getTime()
    })

    toggleSuccess(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >         
          <Avatar alt="Logo"
            src="https://housedownunder.com.au/wp-content/uploads/2021/03/DOWN-UNDER-Logo-RGB.png"
            sx={{ width: 150, height: 150 }} />      
          {
            showSuccess ? 
            <Typography sx={{textAlign: 'center'}} component="div">
              Thank you for joining the queue. 
              {waitTime ? `Your estimated wait time is ${timeConvert(waitTime)}. 
              This is only an estimate and could be 15 minutes quicker or longer depending on the groups in front. ` : ''} 
              We will send you a text message 10 minutes before your turn.
            </Typography>
           :
          (
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="phone"
                  type="tel"
                  label="Mobile phone"
                  name="phone"
                  autoComplete="phone"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="groupSize"
                  type="number"
                  label="Group size"
                  name="groupSize"
                  autoComplete="groupSize"
                />
              </Grid>
              {/* <Grid item xs={6}>
                <ButtonGroup>
                  <Button
                    aria-label="reduce"
                    onClick={() => {
                      setCount(Math.max(count - 1, 1));
                    }}
                  >
                    <RemoveIcon fontSize="small" />
                  </Button>
                  <Button
                    aria-label="increase"
                    onClick={() => {
                      setCount(count + 1);
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </Button>
                </ButtonGroup>
              </Grid>
              <Grid item xs={6}>
                  Group size {count}
              </Grid> */}
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Join the queue
            </Button>
          </Box>
          )}
        </Box>
      </Container>
    </ThemeProvider>
  );
}